<lui-dialog-container>
  <lui-dialog-header>
    <div class="mat-h3">
      {{ data.title }}
    </div>
    <button
      luiDialogClose
      luiIconButton
      size="xl"
      aria-label="Close"
      i18n-aria-label
      (click)="cancel()"
    >
      <mat-icon svgIcon="close_light"></mat-icon>
    </button>
  </lui-dialog-header>
  <lui-dialog-content>
    <div class="mw-md mx-auto" [ngClass]="data.class">
      <div
        *ngIf="data.description"
        class="mb-3"
        [innerHTML]="data.description"
      ></div>

      <form [formGroup]="form" (ngSubmit)="confirm()">
        <formly-form
          *ngIf="data.fields"
          [form]="form"
          [fields]="data.fields"
          [model]="model"
          [options]="data.options || {}"
        ></formly-form>
      </form>
    </div>
  </lui-dialog-content>
  <lui-dialog-actions>
    <button luiTextButton mat-dialog-close (click)="cancel()">
      <mat-icon svgIcon="chevron_left"></mat-icon>
      <ng-container *ngIf="data.cancelLabel; else fallbackCancelLabel">{{
        data.cancelLabel
      }}</ng-container>
      <ng-template #fallbackCancelLabel i18n>Cancel</ng-template>
    </button>
    <button class="ms-auto" luiButton (click)="confirm()" cdkFocusInitial>
      <ng-container *ngIf="data.confirmLabel">{{
        data.confirmLabel
      }}</ng-container>
      <ng-container *ngIf="!data.confirmLabel">
        <ng-container *ngIf="data.mode === 'edit'; else save" i18n
          >Save Changes</ng-container
        >
        <ng-template #save i18n>Save</ng-template>
      </ng-container>
    </button>
  </lui-dialog-actions>
</lui-dialog-container>
